export const KEYS = {
    TOGGLE: ['Meta', 'k'],
    CLOSE: ['Escape']
};
